// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container_oJ5u0","pages":"Pagination_pages_EloDy","active":"Pagination_active_JlZl3"};